// Timing for the spoken step instructions (see the step-5a effect in AiReadingScreen). The
// instruction is scheduled with a delay and the effect cleanup cancels it whenever the step
// changes — so an instruction whose step is left before the delay elapses is never spoken.

// Fast step cascades (buffer replay can run identify→tariffs→read→confirm within milliseconds)
// then announce only the FINAL instruction instead of stuttering through all of them.
export const STEP_INSTRUCTION_DEBOUNCE_MS = 300;

// The camera-permission instruction ("please allow camera access") gets a much longer window.
// When the permission is already granted the camera stream (CAMERA_READY → step 'framing')
// arrives within this window and the cleanup cancels the still-pending announcement, so the
// assistant stays silent instead of reading out a prompt the user never sees (issue #51).
// First-time users who genuinely face the native permission dialog still hear it after the delay
// — and the same text is shown on screen meanwhile.
export const CAMERA_PERMISSION_INSTRUCTION_DELAY_MS = 1200;

export const stepInstructionDelayMs = (step: string): number => {
    return step === 'cameraPermission' ? CAMERA_PERMISSION_INSTRUCTION_DELAY_MS : STEP_INSTRUCTION_DEBOUNCE_MS;
};
